import React from 'react';
import cn from 'classnames';

import './index.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  className?: string;
};

export default function SearchSpinner({ className }: Props) {
  const { tr } = useTranslation();

  return (
    <div
      className={cn(
        'd-flex align-items-center position-absolute rounded-lg bg-white flex-column pt-4 mb-0 w-100 h-50 search-spinner',
        className
      )}
    >
      <div>
        <span className="font-weight-bold">{tr('perform.search.spinner.searching')}</span>
      </div>
      <div />
    </div>
  );
}
